<template>
  <Navbar />
  <ScrollButton />

  <section class="banner-title" style="background-image: url(images/pcb-arge.png)">
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Hizmetlerimiz</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix">
            <li><a href="/">Anasayfa</a></li>
            <li class="active">Hizmetlerimiz</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="services">
  <div class="container">

    <div id="arge" class="service-block">
      <div class="service-content">
        <div class="text">
          <h3>ARGE</h3>
          <p>Elektronik, yazılım ve otomasyon sistemleri alanında projeler geliştiriyor, özgün çözümler sunuyoruz. Ar-Ge çalışmalarımızla ürün kalitesini ve performansını sürekli geliştiriyoruz.</p>
          <ul>
            <li>Yeni ürün geliştirme ve test süreçleri</li>
            <li>Yazılım ve donanım optimizasyonları</li>
            <li>Üniversite iş birlikli projeler</li>
          </ul>
        </div>
        <div class="image">
          <img src="images/arge-design.png" alt="Arge" />
        </div>
      </div>
    </div>

    <div id="tasarim" class="service-block">
      <div class="service-content reverse">
        <div class="text">
          <h3>Tasarım</h3>
          <p>PCB, kontrol kartı ve otomasyon yazılımları gibi sistemlerin tasarımını son teknoloji ve sektöre özel çözümlerle yapıyoruz.</p>
          <ul>
            <li>PCB ve devre kartı şematik tasarımları</li>
            <li>3D modelleme ve bileşen yerleşimi</li>
            <li>Otomasyon sistemleri için özel yazılım</li>
          </ul>
        </div>
        <div class="image">
          <img src="images/tasarim3.png" alt="Tasarım" />
        </div>
      </div>
    </div>

    <div id="numune-prototip" class="service-block">
      <div class="service-content">
        <div class="text">
          <h3>Numune ve Prototip</h3>
          <p>Ürünlerinize entegre çalışabilecek prototipleri hazırlıyor, performans testleri ve raporlamalarla süreçleri destekliyoruz.</p>
          <ul>
            <li>Fonksiyonel prototip üretimi</li>
            <li>Donanım ve yazılım test senaryoları</li>
            <li>Prototip üzerinden iyileştirme çalışmaları</li>
          </ul>
        </div>
        <div class="image">
          <img src="images/tasarim.jpg" alt="Prototip" />
        </div>
      </div>
    </div>

    <div id="uretim" class="service-block">
      <div class="service-content reverse">
        <div class="text">
          <h3>Üretim</h3>
          <p>Gebze'deki modern üretim tesisimizde hızlı, esnek ve kaliteli üretim süreçleriyle farklı miktar ve özellikteki talepleri karşılıyoruz.</p>
          <ul>
            <li>Düşük ve yüksek adetli üretim</li>
            <li>Kalite kontrol ve fonksiyon testleri</li>
            <li>Montaj ve paketleme süreç yönetimi</li>
          </ul>
        </div>
        <div class="image">
          <img src="images/uretim2.jpeg" alt="Üretim" />
        </div>
      </div>
    </div>

  </div>
</section>


  <Footer />
</template>

<script setup>
import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { useHead } from '@vueuse/head';

useHead({
  title: "Hizmetlerimiz | İntek Elektronik",
  meta: [
    {
      name: "description",
      content: "İntek Elektronik olarak Ar-Ge, tasarım, prototipleme ve üretim hizmetlerimizle sektöre özel çözümler sunuyoruz.",
    },
    {
      name: "keywords",
      content: "intek, elektronik, arge, tasarım, pcb tasarımı, prototip üretim, otomasyon, kontrol kartı üretimi, gebze elektronik",
    },
    {
      name: "robots",
      content: "index, follow",
    },
    {
      property: "og:title",
      content: "Hizmetlerimiz | İntek Elektronik",
    },
    {
      property: "og:description",
      content: "İntek Elektronik'in Ar-Ge, tasarım ve üretim hizmetleriyle projelerinize değer katın.",
    },
    {
      property: "og:image",
      content: "https://www.intekelectronic.com.tr/images/pcb-arge.png",
    },
    {
      property: "og:url",
      content: "https://www.intekelectronic.com.tr/hizmetler",
    },
  ],
  link: [
    { rel: "canonical", href: "https://www.intekelectronic.com.tr/hizmetler" }
  ]
});
</script>

<style scoped>

.services {
  padding: 40px 0;
}

.service-block {
  margin-bottom: 40px;
}
.service-block:nth-child(even) {
  background-color: #f8f9fa;
  /* padding: 40px 20px; */
  border-radius: 10px;
}
.service-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
}

.service-content.reverse {
  flex-direction: row-reverse;
}

.text {
  flex: 1;
  min-width: 300px;
}
.text ul {
  margin-top: 10px;
  padding-left: 35px;
  list-style-type: disclosure-closed;
  color: #444;
  font-size: 14px;
  line-height: 1.6;
}
.text ul li::marker {
  color:#ff914d;
}
.text h3 {
  color: #0056b3;
  font-weight: bold;
  margin-bottom: 15px;
}

.text p {
  border-left: 3px solid #ff914d;
  padding-left: 15px;
  font-size: 14px;
  color: #444;
  line-height: 1.6;
}

.image {
  flex: 0.5;
  min-width: 300px;
}

.image img {
  width: 100%;
  max-width: 400px;
  height: 350px;
  border-radius: 5px;
}
.image img:hover {
  transform: scale(1.03);
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .service-content,
  .service-content.reverse {
    flex-direction: column;
  }

  .image img {
    max-width: 100%;
  }
      .banner-title .title-column,
  .banner-title .bread-crumb {
    text-align: center;
  }

  .banner-title .bread-crumb {
    margin-top: 10px;
  }
    .bread-crumb {
    display: none !important;
  }
}
</style>